import * as React from "react";
import { Badge, COLOR } from "baseui/badge";
import { Block } from "baseui/block";
import { HeadingXLarge, HeadingXXLarge } from "baseui/typography";
import { HorizontalSpacer } from "kanopi-components/SpaceWrapper/HorizontalSpacer";
import { MenuActions } from "kanopi-components/MenuActions/MenuActions";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type HeadingActionsBarProps = {
  heading?: string;
  headingLevel?: "page" | "section";
  caption?: string;
  captionColor?: (typeof COLOR)[keyof typeof COLOR];
  actions?: React.ReactNode[];
  menuActions?: React.ReactNode[];
};
export const HeadingActionsBar: React.FC<HeadingActionsBarProps> = (props) => {
  const {
    heading = "",
    headingLevel = "page",
    caption,
    captionColor = COLOR.primary,
    actions,
    menuActions,
  } = props;

  const [, theme] = useStyletron();
  const HeaderComponent = headingLevel === "page" ? HeadingXXLarge : HeadingXLarge;
  return (
    <HorizontalSpacer justifyContent="space-between">
      <HorizontalSpacer>
        <HeaderComponent margin={0} data-testid="layoutHeaderText">
          {heading}
        </HeaderComponent>
        {caption && <Badge color={captionColor} content={caption} />}
      </HorizontalSpacer>
      <HorizontalSpacer justifyContent="space-between">
        <HorizontalSpacer justifyContent="left">{actions}</HorizontalSpacer>
        {menuActions && (
          <Block
            overrides={{
              Block: {
                style: {
                  borderLeftColor: theme.borders.border600.borderColor,
                  borderLeftStyle: theme.borders.border600.borderStyle,
                  borderLeftWidth: theme.borders.border600.borderWidth,
                },
              },
            }}
          >
            <MenuActions actions={menuActions} />
          </Block>
        )}
      </HorizontalSpacer>
    </HorizontalSpacer>
  );
};
